export default __webpack_public_path__ + "static/media/xt-mobile.47c397a3.png";